import { ptlProductValidate } from '../../application/dtos/ptl_product_validate'

export class ptlProductEntity {
    constructor({product_id, description, barcode, quantity, warehouse_id, locations}){
        this.product_id = product_id;
        this.barcode = barcode;
        this.description = description;
        this.quantity = quantity;
        this.warehouse_id = warehouse_id;
        this.locations = locations;
    }

    isValid() {
        // return this.name && this.price >= 0;
        return ptlProductValidate(this);
    }
}